import axiosCall from './interceptor';
import URL, { getTemplateVersion } from '../helper';

export const getDetails = async (data) => {
  const searchParam = new URLSearchParams(data.payload);
  const env = getTemplateVersion(data.env);  
  const url = `${URL.TRANSACTION_SYSTEM_URL}${env}/documentStats?${searchParam}`;
  const response = await axiosCall('get', url);
  return response.data;
};

export const getFailureCountDetails = async (data) => {
  const searchParam = new URLSearchParams(data.payload);
  const env = getTemplateVersion(data.env);
  const url = `${URL.TRANSACTION_SYSTEM_URL}${env}/failureReasonStats?${searchParam}`;
  const response = await axiosCall('get', url);
  return response.data;
};

export const getTopTenFailureTemplateDetails = async (data) => {
  const searchParam = new URLSearchParams(data.payload);
  const env = getTemplateVersion(data.env);
  const url = `${URL.TRANSACTION_SYSTEM_URL}${env}/topTenFailedTemplates?${searchParam}`;
  const response = await axiosCall('get', url);
  return response.data;
};

export const getFailureDocumentList = async ({ payload, env}) => {
  const searchParam = new URLSearchParams(payload);
  const environment = getTemplateVersion(env);
  const url = `${URL.TRANSACTION_SYSTEM_URL}${environment}/failedDocumentList?${searchParam}`;
  const response = await axiosCall('get', url);
  return response.data;
};

export const getDocumentDashboardChartData = async () => {
  const searchParam = new URLSearchParams({ limit: 12 });
  const url = `${URL.TRANSACTION_SYSTEM_URL}documentDashboardData?${searchParam}`;
  const response = await axiosCall('get', url);
  return response.data;
};

export const getShortMessage = async (payload) => {
  const searchParam = new URLSearchParams(payload);
  const url = `${URL.BASE_URL}messageSentDailyMetrics?${searchParam}`;
  const response = await axiosCall('get', url);
  return response.data;
};

export const getShortMessageChartData = async () => {
  const searchParam = new URLSearchParams({ limit: 12 });
  const url = `${URL.BASE_URL}messageSentMetrics?${searchParam}`;
  const response = await axiosCall('get', url);
  return response.data;
};

export const getShortMessageTableData = async (ids) => {
  const searchParam = new URLSearchParams({ ids: ids });
  const url = `${URL.BASE_URL}failedMessageData?${searchParam}`;
  const response = await axiosCall('get', url);
  return response.data;
};
